export enum AugloopKeys {
    SessionUrl = "SessionUrl",
    SessionGuid = "SessionGuid",
    ServiceUrl = "ServiceUrl",
    InitializeAugloopRuntimeManagerDuration = "InitializeAugloopRuntimeManagerDuration",
    CreateAugloopRutimeManagerPromise = "CreateAugloopRutimeManagerPromise",
    OnSessionConnect = "OnSessionConnect",
    OnSessionDisconnect = "OnSessionDisconnect",
    OnSessionReconnect = "OnSessionReconnect",
    OnSessionDisconnectError = "OnSeessionDisconnectError",
    OnSessionClose = "OnSessionClose",
    OnSessionCloseReconnectAllowed = "OnSessionCloseReconnectAllowed",
    OnSessionCloseReason = "OnSessionCloseReason",
    SessionConnectAttempt = "OnSessionConnectAttempt",
    IsConnectedToAL = `IsConnectedToAL`, /* True if a server connection has been made at least once. */
    HasConnectedToAL = `HasConnectedToAL`, /* True if the session is currently connected to the server. */
    ConnectionClosedWithAL = `ConnectionClosedWithAL` /* True if the session has been closed. */
};